import { type EnvironmentProviders } from '@angular/core';

import { EcosioSettingsPermissions, createEcosioSettingsPlugin } from '@mp/integrations/ecosio/settings/feature';
import { provideModuleInfo } from '@mp/shared/util';
import { provideModuleOrganizationSettings, provideModulePermissions } from '@mpk/shared/data-access';

const moduleName = 'Ecosio';

export function provideEcosioFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'ECOSIO',
    }),
    provideModulePermissions(moduleName, EcosioSettingsPermissions),
    provideModuleOrganizationSettings(moduleName, createEcosioSettingsPlugin),
  ];
}
